//Node imports
import { IntroOutroViewBehavior, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { Container, detectDeviceEnvironmentConstants, detectDeviceEnvironmentConstants as deviceEnvironment, Graphics, ingenuity } from "@quest/base-core";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";

export class IntroOutroViewGame extends IntroOutroViewBehavior {

    public outroJackpotContainer: Container;
    public outroJackpotMainContainer: Container;
    private IntroOutroContainer:Container;
    private baseGameMask: Graphics;


    /**
   * method resize override update resizing of FG intro outro
   */
    protected resize(evt?: any): void {
        super.resize(evt);
        if (!ingenuity.deviceEnv.isDesktop && this.outroJackpotMainContainer) {
            this.setJpUIContainerAlignment();
        }
        if (ingenuity.deviceEnv.getOrientation() === deviceEnvironment.constants.ORIENTATION.PORTRAIT) {
            this.y = innerHeight / 2;
            this.pivot.set(ingenuity.configData.height / 2, ingenuity.configData.width / 2);

            const container_BG: Container = this.getContainerByID("fgIntroSpineMainContainerPortrait_BG")
            const OutroSpineContainer: Container = this.getContainerByID("fgOutroSpineContainer");
            if (ingenuity.deviceEnv.getIsIpad()) {
                this.scale.set(ingenuity.deviceEnv.getPortraitMaxScale());
                container_BG.scale.set(1);
                OutroSpineContainer.scale.set(1);
            } else {
                this.scale.set(ingenuity.deviceEnv.getPortraitScale());
                const maxScaling: number = ingenuity.deviceEnv.getPortraitMaxScale() / ingenuity.deviceEnv.getPortraitScale();
                container_BG.scale.set(maxScaling);
                OutroSpineContainer.scale.set(maxScaling);
            }
                   this.baseGameMask = this.getShapeById("baseGameMask") as Graphics;
              if (this.IntroOutroContainer) {
                ((this.IntroOutroContainer).mask as Graphics) = null;
              }
        }
        else {
            this.pivot.set(ingenuity.configData.width * SlotConstantsBehavior.HALF_CONVERTER, ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER);
            this.x = innerWidth * SlotConstantsBehavior.HALF_CONVERTER;
            if (ingenuity.deviceEnv.isDesktop) {
                this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER)
            }
            const heightScale = innerHeight / ingenuity.configData.height;
            this.scale.set(heightScale);
            this.scaleComponents();
            this.getContainerByID("fgOutroSpineContainer").scale.set(1);
              this.baseGameMask = this.getShapeById("baseGameMask") as Graphics;
              if (this.IntroOutroContainer) {
                (this.IntroOutroContainer.mask as Graphics) = this.baseGameMask;
            }
        }
    }

    //override to resize view during broken
    protected initialiseElements(): void {
        super.initialiseElements();
        this.outroJackpotMainContainer = this.getContainerByID("outroJackpotMainContainer");
        this.outroJackpotContainer = this.getContainerByID("outroJackpotContainer");
        this.IntroOutroContainer = this.getContainerByID("IntroOutroContainer");
        if (ingenuity.deviceEnv.getOrientation() !== constants.ORIENTATION.PORTRAIT) {
            this.scaleComponents();
        } else {
            this.introTextContainer.scale.set(1);
        }
        this.initializeComponents();
    }

    /**
   * Method method to set Jackpot UI container center alignment.
   */
    public setJpUIContainerAlignment(): void {
        const emptySpace: number = this.outroJackpotMainContainer.json.w - this.outroJackpotContainer.width;
        this.outroJackpotContainer.x = this.outroJackpotContainer.json.x + emptySpace / 2;
    }
            /**
         * Add to change outro meter parent
         */
      public  changeOutroMeterParent() {
            if (this.outroTextContainer) {
                if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.LANDSCAPE) {
                    this.freegameOutroSpineCont.addChild(this.outroTextContainer);
                }
                else {
                    this.outroMainContainer.addChild(this.outroTextContainer);
                    this.outroMainContainer.addChild(this.getContainerByID("OutroTapToContinue"));
                }
            }
        }
}